import _ from "lodash";
import { SELECT_TAG_CONFIG } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        selectTagConfig: _.cloneDeep(constants.SELECT_TAG_CONFIG_INPUT)
    }
}

const selectTagConfigReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SELECT_TAG_CONFIG.SET_SELECT_TAG_CONFIG_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case SELECT_TAG_CONFIG.SET_SELECT_TAG_CONFIG:
        case SELECT_TAG_CONFIG.SET_SELECT_TAG_CONFIG_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    selectTagConfig: action.selectTagConfig
                }
            })
        default:
            return state
    }
}

export default selectTagConfigReducer